import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import AddReferenceModal from './AddReferenceModal';

interface AddReferenceButtonProps {
  candidateId: string;
  onReferenceAdded?: () => void;
  disabled?: boolean;
}

const AddReferenceButton = ({ candidateId, onReferenceAdded, disabled = false }: AddReferenceButtonProps) => {
  const { t } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSuccess = () => {
    if (onReferenceAdded) {
      onReferenceAdded();
    }
  };

  return (
    <>
      <button
        onClick={handleOpenModal}
        disabled={disabled}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title={t('candidates.addReferenceButton.title')}
      >
        <Plus className="w-3.5 h-3.5" />
        {t('candidates.addReferenceButton.label')}
      </button>
      
      {isModalOpen && (
        <AddReferenceModal 
          candidateId={candidateId}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
};

export default AddReferenceButton;